export default __webpack_public_path__ + "static/media/image-icon.59742618.svg";